(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-india-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  document.querySelectorAll('[data-bb-india-header] .bb-india-disclosure[open]').forEach(function(details) {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-bb-india-header] .bb-india-disclosure[open]').forEach(function(details) {
    details.open = false;
    if (details.contains(document.activeElement)) details.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-market-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bb-market-header]').forEach(header => {
  if (header.dataset.menuReady) return;
  header.dataset.menuReady = 'true';
  const brands = header.querySelector('[data-bb-brands]');
  if (brands) {
    const input = brands.querySelector('[data-bb-brands-input]');
    const clear = brands.querySelector('[data-bb-brands-clear]');
    const count = brands.querySelector('[data-bb-brands-count]');
    const empty = brands.querySelector('[data-bb-brands-empty]');
    const list = brands.querySelector('[data-bb-brands-list]');
    const fallback = brands.querySelector('[data-bb-brands-fallback]');
    const more = brands.querySelector('[data-bb-brands-more]');
    const normalize = value => value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, '');
    let items;
    let matches = [];
    let shown = 0;
    const appendBrands = () => {
      const fragment = document.createDocumentFragment();
      let firstLink;
      const end = Math.min(shown + 100, matches.length);
      for (let index = shown; index < end; index += 1) {
        const item = document.createElement('li');
        item.dataset.bbBrand = '';
        const link = document.createElement('a');
        link.setAttribute('href', matches[index].href);
        link.textContent = matches[index].label;
        item.append(link);
        fragment.append(item);
        firstLink ||= link;
      }
      list.append(fragment);
      shown = end;
      count.textContent = count.dataset.shownTemplate.replaceAll('__BB_BRAND_SHOWN__', String(shown)).replaceAll('__BB_BRAND_COUNT__', String(matches.length));
      more.hidden = shown >= matches.length;
      empty.hidden = matches.length !== 0;
      return firstLink;
    };
    const filterBrands = () => {
      if (!items) return;
      const query = normalize(input.value);
      matches = query ? items.filter(item => item.name.includes(query)) : items;
      shown = 0;
      list.replaceChildren();
      list.scrollTop = 0;
      appendBrands();
      clear.hidden = input.value.length === 0;
    };
    const initializeBrands = () => {
      if (items) return;
      const template = document.createElement('template');
      template.innerHTML = fallback.textContent;
      items = Array.from(template.content.querySelectorAll('[data-bb-brand] a'), link => ({
        label: link.textContent,
        name: normalize(link.textContent),
        href: link.getAttribute('href')
      }));
      template.content.replaceChildren();
      fallback.remove();
      brands.querySelector('[data-bb-brands-search]').hidden = false;
      list.hidden = false;
      filterBrands();
    };
    input.addEventListener('input', filterBrands);
    input.addEventListener('search', filterBrands);
    clear.addEventListener('click', () => {
      input.value = '';
      filterBrands();
      input.focus();
    });
    more.addEventListener('click', () => {
      const restoreFocus = document.activeElement === more;
      const firstLink = appendBrands();
      if (restoreFocus && firstLink) firstLink.focus();
    });
    brands.addEventListener('toggle', () => {
      if (brands.open) initializeBrands();
    });
    if (brands.open) initializeBrands();
  }
  header.addEventListener('toggle', event => {
    if (!event.target.matches('.bb-market-menu') || !event.target.open) return;
    header.querySelectorAll('.bb-market-menu[open]').forEach(menu => { if (menu !== event.target) menu.open = false; });
  }, true);
  header.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.bb-market-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    header.querySelectorAll('.bb-market-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-market-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-market-carousel')) {
  customElements.define('bb-market-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const rail = this.querySelector('.bb-market-row__rail');
      const buttons = Array.from(this.querySelectorAll('[data-direction]'));
      const refresh = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        buttons.forEach(button => {
          button.hidden = max < 2;
          button.disabled = Number(button.dataset.direction) < 0 ? rail.scrollLeft < 2 : rail.scrollLeft > max - 2;
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => rail.scrollBy({left: Number(button.dataset.direction) * rail.clientWidth * 0.85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
      rail.addEventListener('scroll', refresh, {passive: true});
      this.resizeObserver = new ResizeObserver(refresh);
      this.resizeObserver.observe(rail);
      refresh();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-recently-viewed')) {
  customElements.define('bb-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.key = 'beautybrats-recently-viewed-v1';
      this.content = this.querySelector('.bb-discovery');
      this.rail = this.querySelector('[data-recent-products]');
      this.querySelector('[data-clear-history]').addEventListener('click', () => {
        try { localStorage.removeItem(this.key); } catch {}
        this.requestId = (this.requestId || 0) + 1;
        this.rail.replaceChildren();
        this.content.hidden = true;
      });
      let history = [];
      try {
        const stored = JSON.parse(localStorage.getItem(this.key) || '[]');
        const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
        if (Array.isArray(stored)) {
          const seen = new Set();
          history = stored.filter(item => {
            if (!item || typeof item.handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(item.handle) || !Number.isFinite(item.viewed) || item.viewed < cutoff || seen.has(item.handle)) return false;
            seen.add(item.handle);
            return true;
          }).slice(0, 20);
        }
        const current = this.dataset.current;
        if (current) history = [{ handle: current, viewed: Date.now() }, ...history.filter(item => item.handle !== current)].slice(0, 20);
        localStorage.setItem(this.key, JSON.stringify(history));
      } catch {}
      const previous = history.filter(item => item.handle !== this.dataset.current);
      if (previous.length) this.loadProducts(previous);
    }

    async loadProducts(history) {
      const requestId = this.requestId = (this.requestId || 0) + 1;
      const root = this.dataset.root.replace(/\/?$/, '/');
      const limit = Math.min(8, Math.max(1, Number(this.dataset.limit) || 8));
      const available = [];
      for (let offset = 0; offset < history.length && available.length < limit;) {
        if (!this.isConnected || requestId !== this.requestId) return;
        const batch = history.slice(offset, offset + Math.min(4, limit - available.length));
        offset += batch.length;
        const cards = await Promise.all(batch.map(async item => {
          try {
            const url = new URL(`${root}products/${encodeURIComponent(item.handle)}`, window.location.origin);
            url.searchParams.set('section_id', 'bb-recent-product-card');
            const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
            if (!response.ok) return null;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const card = doc.querySelector('[data-recent-card] .bbi-card');
            return card ? document.importNode(card, true) : null;
          } catch { return null; }
        }));
        if (!this.isConnected || requestId !== this.requestId) return;
        available.push(...cards.filter(Boolean));
        this.rail.replaceChildren(...available);
        this.content.hidden = available.length === 0;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-similar-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-similar-products')) {
    customElements.define('bb-similar-products', class extends HTMLElement {
      connectedCallback() {
        if (this.requested || this.observer || !this.dataset.url || this.dataset.recommendationsReady === 'true') return;
        if (this.hidden || !('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.observer = null;
          this.loadRecommendations();
        }, { rootMargin: '300px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.controller) this.controller.abort();
      }

      async loadRecommendations() {
        if (this.requested) return;
        this.requested = true;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = html.querySelector('bb-similar-products[data-recommendations-ready="true"]');
          if (!replacement || !replacement.querySelector('.bbi-card') || !this.isConnected) return;
          if (this.contains(document.activeElement)) return;
          this.replaceChildren(...replacement.childNodes);
          this.dataset.recommendationsReady = 'true';
          this.hidden = false;
        } catch {
          return;
        } finally {
          clearTimeout(timeout);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
